/**
 * Detects if a string is rich text HTML from Tiptap.
 * Per specification: Only consider HTML if it begins with <p, <ul, <ol, or <pre.
 */
export const isRichTextHtml = (text?: string | null): boolean => {
  if (!text || typeof text !== 'string') return false;
  const trimmed = text.trim();
  return /^<(p|ul|ol|pre)(\s|>)/i.test(trimmed);
};
